import { faArrowLeft, faCircleExclamation } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, IconButton, OutlinedInput, Typography } from "@mui/material"
import { useFormik } from "formik"
import moment from "moment"
import React, { useEffect, useState } from 'react'
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext"
import { TokenRegisterType } from "../../../interfaces/enum/TokenRegisterType"
import { TokenReceivedRegisterProps } from "../../../interfaces/props/register/TokenReceivedRegisterProps"
import { TokenRegisterValidation } from "../../../interfaces/validation/Register/TokenRegisterValidation"
import { sxButtonOptionRecovery, sxButtonText, sxLabel, sxTextButtonCapitalize, sxTypographyTitle, sxValidationMessage } from "../sxProps"
import { onlyNumbers } from "../../../utils/OnlyNumbers"

const TokenReceived: React.FC<TokenReceivedRegisterProps> = ({
  tokenRegisterType,
  formBack,
  openPasswordDefinition,
  openTokenReceived,
  registerToken
}) => {
  const formik = useFormik({
    initialValues: { token: '' },
    validationSchema: TokenRegisterValidation,
    onSubmit: (values) => {
      if (tokenValidation(values.token))
        openPasswordDefinition()
    },
    validateOnChange: false
  })


  const tokenValidation = (token: string): boolean => {
    if (token === registerToken.numeroTokenUnimed && registerToken.dtExpiracao > moment().format()) {
      return true
    };

    formik.setErrors({
      token: "Token inválido ou expirado"
    });
    return false;
  }

  const [timeOutReSendTokenBlocked, setTimeOutReSendTokenBlocked] = useState(60);
  const [reSendTokenBlocked, setReSendTokenBlocked] = useState(true)

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimeOutReSendTokenBlocked(prevTempo => prevTempo - 1);
    }, 1000);

    if (timeOutReSendTokenBlocked === 0) {
      setReSendTokenBlocked(false)
    }

    return () => clearInterval(intervalId);
  }, [timeOutReSendTokenBlocked]);

  const { textStyleAccessibility, buttonStyleAccessibility, buttonTextStyleAccessibility } = useAccessibility();

  return (
    <div style={textStyleAccessibility} className='width-100 flex-gap-16'>
      <div className='password-recovery-container-text'>
        <div className='width-100'>
          <IconButton onClick={() => formBack()} type="button">
            <FontAwesomeIcon style={textStyleAccessibility} icon={faArrowLeft} />
          </IconButton>
          <Typography style={textStyleAccessibility} sx={sxTypographyTitle} className='margin-bottom-painel-rigth'>Definir senha</Typography>
        </div>
        <div className='container-text-recovery '>
          {
            tokenRegisterType === TokenRegisterType.SMS ?
              <span style={textStyleAccessibility} className='login-text login-text-center'>
                Enviamos o Token via SMS ao número de celular cadastrado, basta digitá-lo antes de expirar, no campo a seguir e continuar. Ele tem validade de 3 horas e 59 minutos minutos.</span>
              :
              <span style={textStyleAccessibility} className='login-text login-text-center'>
                Enviamos o Token ao e-mail cadastrado, basta digitá-lo antes de expirar, no campo a seguir e continuar. Ele tem validade de 3 horas e 59 minutos minutos.</span>
          }
        </div>
      </div>
      <form onSubmit={formik.handleSubmit} className='width-100'>
        <div className='width-100'>
          <div className='width-100 margin-bottom-20'>
            <Typography style={textStyleAccessibility} sx={sxLabel}>Token</Typography>
            <OutlinedInput
              fullWidth
              type={'text'}
              placeholder='Digite o token recebido'
              onChange={(event) => { formik.setFieldValue('token', onlyNumbers(event.target.value)) }}
              name='token'
              error={!!formik.errors.token}
              maxRows={1}
              value={formik.values.token}
              inputProps={{ maxLength: 6 }}
            />
            {formik.errors.token &&
              <div className="container-validation-message">
                <FontAwesomeIcon icon={faCircleExclamation} size='sm' color='#D84141' />
                <Typography sx={sxValidationMessage} style={textStyleAccessibility}>{formik.errors.token}</Typography>
              </div>
            }
          </div>
        </div>
        <div className="container-recovery-password-options">
          <Button style={buttonStyleAccessibility} sx={sxButtonOptionRecovery} variant='contained' type='submit'>
            <Typography style={buttonTextStyleAccessibility}>CONTINUAR</Typography>
          </Button>
          {tokenRegisterType === TokenRegisterType.SMS ?
            <Button
              sx={sxButtonOptionRecovery}
              variant='outlined'
              disabled={reSendTokenBlocked}
              onClick={() => {
                formik.resetForm();
                setReSendTokenBlocked(true);
                setTimeOutReSendTokenBlocked(60);
                openTokenReceived(TokenRegisterType.SMS);
              }}
            >
              <Typography style={textStyleAccessibility} sx={sxTextButtonCapitalize}>REENVIAR TOKEN POR SMS {timeOutReSendTokenBlocked >= 0 && `(${timeOutReSendTokenBlocked} s)`}</Typography>
            </Button>
            :
            <Button
              sx={sxButtonOptionRecovery}
              variant='outlined'
              disabled={reSendTokenBlocked}
              onClick={() => {
                formik.resetForm();
                setReSendTokenBlocked(true);
                setTimeOutReSendTokenBlocked(60);
                openTokenReceived(TokenRegisterType.Email);
              }}
            >
              <Typography style={textStyleAccessibility} sx={sxTextButtonCapitalize}>REENVIAR TOKEN POR EMAIL {timeOutReSendTokenBlocked >= 0 && `(${timeOutReSendTokenBlocked} s)`}</Typography>
            </Button>
          }
          {
            tokenRegisterType === TokenRegisterType.SMS ?
              <Button sx={sxButtonOptionRecovery} variant='text' onClick={() => {
                formik.resetForm();
                setReSendTokenBlocked(true);
                setTimeOutReSendTokenBlocked(60);
                openTokenReceived(TokenRegisterType.Email);
              }}>
                <Typography style={textStyleAccessibility} sx={sxButtonText}>ENVIAR TOKEN POR EMAIL</Typography>
              </Button>
              :
              <Button sx={sxButtonOptionRecovery} variant='text' onClick={() => {
                formik.resetForm();
                setReSendTokenBlocked(true);
                setTimeOutReSendTokenBlocked(60);
                openTokenReceived(TokenRegisterType.SMS);
              }}>
                <Typography style={textStyleAccessibility} sx={sxButtonText}>ENVIAR TOKEN POR SMS</Typography>
              </Button>
          }
        </div>
      </form>
    </div>
  )
}

export default TokenReceived